// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"DialogWindow_ModalWrapper__TZ6Mn","ModalCard":"DialogWindow_ModalCard__2D2Tz"};